import {
  createAvailabilityException as publicCreateAvailabilityException,
  getAvailabilityException as publicGetAvailabilityException,
  updateAvailabilityException as publicUpdateAvailabilityException,
  deleteAvailabilityException as publicDeleteAvailabilityException,
  queryAvailabilityExceptions as publicQueryAvailabilityExceptions,
  typedQueryAvailabilityExceptions as publicTypedQueryAvailabilityExceptions,
  bulkCreateAvailabilityExceptions as publicBulkCreateAvailabilityExceptions,
  bulkUpdateAvailabilityExceptions as publicBulkUpdateAvailabilityExceptions,
  bulkUpdateAvailabilityExceptionTags as publicBulkUpdateAvailabilityExceptionTags,
  bulkUpdateAvailabilityExceptionTagsByFilter as publicBulkUpdateAvailabilityExceptionTagsByFilter,
} from './restaurants-v1-availability-exception-availability-exceptions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  AvailabilityExceptionQuery,
  AvailabilityExceptionsQueryBuilder,
  typedQueryAvailabilityExceptions as universalTypedQueryAvailabilityExceptions,
} from './restaurants-v1-availability-exception-availability-exceptions.universal.js';
import { onAvailabilityExceptionCreated as publicOnAvailabilityExceptionCreated } from './restaurants-v1-availability-exception-availability-exceptions.public.js';
import { onAvailabilityExceptionDeleted as publicOnAvailabilityExceptionDeleted } from './restaurants-v1-availability-exception-availability-exceptions.public.js';
import { onAvailabilityExceptionUpdated as publicOnAvailabilityExceptionUpdated } from './restaurants-v1-availability-exception-availability-exceptions.public.js';

function customQueryAvailabilityExceptions(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryAvailabilityExceptions(httpClient)(),
    typedQueryFunction: (query: AvailabilityExceptionQuery) =>
      publicTypedQueryAvailabilityExceptions(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): AvailabilityExceptionsQueryBuilder;
  function overloadedQuery(
    query: AvailabilityExceptionQuery
  ): ReturnType<typeof universalTypedQueryAvailabilityExceptions>;
  function overloadedQuery(query?: AvailabilityExceptionQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createAvailabilityException: MaybeContext<
  BuildRESTFunction<typeof publicCreateAvailabilityException> &
    typeof publicCreateAvailabilityException
> = /*#__PURE__*/ createRESTModule(publicCreateAvailabilityException);
export const getAvailabilityException: MaybeContext<
  BuildRESTFunction<typeof publicGetAvailabilityException> &
    typeof publicGetAvailabilityException
> = /*#__PURE__*/ createRESTModule(publicGetAvailabilityException);
export const updateAvailabilityException: MaybeContext<
  BuildRESTFunction<typeof publicUpdateAvailabilityException> &
    typeof publicUpdateAvailabilityException
> = /*#__PURE__*/ createRESTModule(publicUpdateAvailabilityException);
export const deleteAvailabilityException: MaybeContext<
  BuildRESTFunction<typeof publicDeleteAvailabilityException> &
    typeof publicDeleteAvailabilityException
> = /*#__PURE__*/ createRESTModule(publicDeleteAvailabilityException);
export const bulkCreateAvailabilityExceptions: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateAvailabilityExceptions> &
    typeof publicBulkCreateAvailabilityExceptions
> = /*#__PURE__*/ createRESTModule(publicBulkCreateAvailabilityExceptions);
export const bulkUpdateAvailabilityExceptions: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateAvailabilityExceptions> &
    typeof publicBulkUpdateAvailabilityExceptions
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateAvailabilityExceptions);
export const bulkUpdateAvailabilityExceptionTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateAvailabilityExceptionTags> &
    typeof publicBulkUpdateAvailabilityExceptionTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateAvailabilityExceptionTags);
export const bulkUpdateAvailabilityExceptionTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateAvailabilityExceptionTagsByFilter> &
    typeof publicBulkUpdateAvailabilityExceptionTagsByFilter
> = /*#__PURE__*/ createRESTModule(
  publicBulkUpdateAvailabilityExceptionTagsByFilter
);
export const queryAvailabilityExceptions: MaybeContext<
  BuildRESTFunction<typeof customQueryAvailabilityExceptions> &
    typeof customQueryAvailabilityExceptions
> = /*#__PURE__*/ createRESTModule(customQueryAvailabilityExceptions);
/**
 * Triggered when an availability exception is created.
 */
export const onAvailabilityExceptionCreated: BuildEventDefinition<
  typeof publicOnAvailabilityExceptionCreated
> &
  typeof publicOnAvailabilityExceptionCreated = createEventModule(
  publicOnAvailabilityExceptionCreated
);
/**
 * Triggered when an availability exception is deleted.
 */
export const onAvailabilityExceptionDeleted: BuildEventDefinition<
  typeof publicOnAvailabilityExceptionDeleted
> &
  typeof publicOnAvailabilityExceptionDeleted = createEventModule(
  publicOnAvailabilityExceptionDeleted
);
/**
 * Triggered when an availability exception is updated.
 */
export const onAvailabilityExceptionUpdated: BuildEventDefinition<
  typeof publicOnAvailabilityExceptionUpdated
> &
  typeof publicOnAvailabilityExceptionUpdated = createEventModule(
  publicOnAvailabilityExceptionUpdated
);

export {
  AffectedMethods,
  Type,
  SortOrder,
  WebhookIdentityType,
} from './restaurants-v1-availability-exception-availability-exceptions.universal.js';
export {
  AvailabilityException,
  AffectedFulfillmentMethods,
  AffectedFulfillmentMethodsAffectedMethodsOptionsOneOf,
  SpecificFulfillmentMethodsImpactScope,
  ExtendedFields,
  Tags,
  TagList,
  CreateAvailabilityExceptionRequest,
  CreateAvailabilityExceptionResponse,
  GetAvailabilityExceptionRequest,
  GetAvailabilityExceptionResponse,
  UpdateAvailabilityExceptionRequest,
  UpdateAvailabilityExceptionResponse,
  DeleteAvailabilityExceptionRequest,
  DeleteAvailabilityExceptionResponse,
  QueryAvailabilityExceptionsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryAvailabilityExceptionsResponse,
  CursorPagingMetadata,
  Cursors,
  BulkCreateAvailabilityExceptionsRequest,
  BulkCreateAvailabilityExceptionsResponse,
  BulkCreateAvailabilityExceptionsResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkUpdateAvailabilityExceptionsRequest,
  MaskedAvailabilityException,
  BulkUpdateAvailabilityExceptionsResponse,
  BulkAvailabilityExceptionResult,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  BulkUpdateAvailabilityExceptionTagsRequest,
  BulkUpdateAvailabilityExceptionTagsResponse,
  BulkUpdateAvailabilityExceptionTagsResult,
  BulkUpdateAvailabilityExceptionTagsByFilterRequest,
  BulkUpdateAvailabilityExceptionTagsByFilterResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  AvailabilityExceptionCreatedEnvelope,
  AvailabilityExceptionDeletedEnvelope,
  AvailabilityExceptionUpdatedEnvelope,
  UpdateAvailabilityException,
  AvailabilityExceptionsQueryResult,
  AvailabilityExceptionsQueryBuilder,
  AvailabilityExceptionQuerySpec,
  BulkCreateAvailabilityExceptionsOptions,
  BulkUpdateAvailabilityExceptionsOptions,
  BulkUpdateAvailabilityExceptionTagsOptions,
  BulkUpdateAvailabilityExceptionTagsByFilterOptions,
} from './restaurants-v1-availability-exception-availability-exceptions.universal.js';
export { utils } from './restaurants-v1-availability-exception-availability-exceptions.universal.js';
export {
  AffectedMethodsWithLiterals,
  TypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BulkUpdateAvailabilityExceptionTagsApplicationErrors,
  BulkUpdateAvailabilityExceptionTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  AvailabilityExceptionQuery,
} from './restaurants-v1-availability-exception-availability-exceptions.universal.js';
